export { LongPressModule } from './long-press.module'
export { LongPressDirective } from './long-press.directive';
